module.exports = __webpack_public_path__ + "static/media/tshirt2new.98649a18.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/tshirt2new.png
// module id = 619
// module chunks = 0